import { render, staticRenderFns } from "./carousel_productos.vue?vue&type=template&id=cedf1808"
import script from "./carousel_productos.vue?vue&type=script&lang=js"
export * from "./carousel_productos.vue?vue&type=script&lang=js"
import style0 from "./carousel_productos.vue?vue&type=style&index=0&id=cedf1808&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports